import {assert} from 'assert-ts';
import type {Agent} from 'api/types';
import {isAgentValue} from './isAgentValue';

export const assertAgentValue = (value: unknown): Agent => {
  assert(isAgentValue(value), 'assertAgentValue: invalid agent', {value});

  return value as Agent;
};
